<template>
  <div class="ricerca col-24 no-padding">
    <ricerca-panel :filtri="filtriRicerca"
                   @closeRicerca="closeRicerca"
                   @changeValueOrClick="changeValueOrClick"
                   @cerca="cerca"></ricerca-panel>
  </div>
</template>

<script>
  import {bus} from '../../Bus'
  import RicercaPanel from '@/components/ServiceComponents/RicercaPanel'
  import moment from 'moment'

  export default {
    name: 'Ricerca',
    components: {RicercaPanel},
    i18n: {
      messages: {
        it_IT: {
          ricerca: {
            stato: 'Stato',
            fornitore: 'Fornitore',
            stabDestinazione: 'Stabilimento di Destinazione',
            ricerca: 'Cerca',
            scegli: 'Scegli...',
            filtri: 'Filtri',
            statoAvanz: 'Stato Avanzamento',
            locProvenienza: 'Località di Provenienza',
            subFornitore: 'Subfornitore',
            numTrattativa: 'Numero Trattativa',
            dataTrattativa: 'Data Trattativa',
            periodoVal: 'Periodo Validità',
            periodoConsSped: 'Periodo Consegna/Spedizione'
          }
        },
        fr_FR: {
          ricerca: {
          }
        },
        es_ES: {
          ricerca: {
          },
        },
        de_DE: {
          ricerca: {
            stato: 'Zustand',
            fornitore: 'Fornitore',
            stabDestinazione: 'Werk',
            ricerca: 'Suchen',
            scegli: 'Wählen...',
            filtri: 'Filter',
            statoAvanz: 'Stand der Durchfuehrung',
            locProvenienza: 'Ursprungsort',
            subFornitore: 'Zuliefer',
            numTrattativa: 'Verhndlung nummer',
            dataTrattativa: 'Datum der Verhandlung',
            periodoVal: 'Gueltigkeit',
            periodoConsSped: 'Lieferzeit'
          }
        },
        en_GB: {
          ricerca: {
          }
        }
      }
    },
    data () {
      return {
        filtriRicerca: {
          loading: false,
          titolo: '',
          valueSelected: {
            0: '',
            1: '',
            2: {},
            3: '',
            4: '',
            5: '',
            6: '',
            7: [],
            8: []
          },
          dati: {
            0: [],
            1: [],
            2: [],
            3: [],
            4: []
          },
          filtri: [
            // Select con le country a cui è abilitato l'utente
            {
              type: 'select',
              myLabel: '',
              value: 'country',
              label: 'desc',
              key: 'country',
              onChangeOrClick: 'changeCountry',
              ifClearable: false,
              ifDisabled: false
            },
            // Select: stato di avanzamento
            {
              type: 'select',
              myLabel: '',
              value: 'codAvanz',
              label: 'desAvanz',
              key: 'codAvanz',
              onChangeOrClick: 'changeStatoAvanz',
              ifClearable: true,
              ifDisabled: false
            },
            // Select: stabilimenti di destinazione
            {
              type: 'select-with-object',
              myLabel: '',
              label: ['descStab'],
              key: 'key',
              onChangeOrClick: 'changeStab',
              ifClearable: true,
              ifDisabled: false,
              ifShow: true
            },
            // Select: località di provenienza
            {
              type: 'select',
              myLabel: '',
              value: 'codLoca',
              label: 'desLoca',
              key: 'codLoca',
              onChangeOrClick: 'changeLocProv',
              ifClearable: true,
              ifDisabled: false
            },
            // Select: subfornitori
            {
              type: 'select',
              myLabel: '',
              value: 'codSubfor',
              label: 'desSubfor',
              key: 'codSubfor',
              onChangeOrClick: 'changeSubForn',
              ifClearable: true,
              ifDisabled: false
            },
            // Input: numero trattativa
            {
              type: 'input',
              myLabel: '',
              ifClearable: true,
              onChangeOrClick: 'changeNumTrattativa'
            },
            // Date picker: data trattativa
            {
              type: 'dt-picker',
              myLabel: '',
              ifClearable: true,
              format: 'dd/MM/yyyy',
              valueFormat: 'dd/MM/yyyy',
              typePicker: 'date',
              onChangeOrClick: 'changeDataTrattativa'
            },
            // Date picker (range): periodo validità
            {
              type: 'dt-picker',
              myLabel: '',
              ifClearable: true,
              format: 'dd/MM/yyyy',
              valueFormat: 'dd/MM/yyyy',
              typePicker: 'daterange',
              onChangeOrClick: 'changePeriodoVal'
            },
            // Date picker (range): periodo consegna/spedizione
            {
              type: 'dt-picker',
              myLabel: '',
              ifClearable: true,
              format: 'dd/MM/yyyy',
              valueFormat: 'dd/MM/yyyy',
              typePicker: 'daterange',
              onChangeOrClick: 'changePeriodoConsSped'
            }
          ]
        },
        codLang: sessionStorage.getItem('codLang'),
        form: {
          country: '',
          fornitore: {},
          statoAvanz: '',
          stabDest: {},
          locProv: '',
          subFornitore: '',
          numTrattativa: '',
          dataTrattativa: '',
          periodoVal: [],
          periodoConsSped: []
        },
        codForn: '',
        codFornAdmin: {}
      }
    },
    activated: function () {
      this.init()
    },
    mounted: function () {
      bus.$on('Header_SetCodFornAdmin', () => {
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
          this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
        } else {
          this.$set(this, 'codFornAdmin', {})
          this.$set(this, 'codForn', '')
        }
        if (!this._inactive) {
          this.filtriRicerca.valueSelected[1] = ''
          this.filtriRicerca.valueSelected[2] = {}
          this.filtriRicerca.valueSelected[3] = ''
          this.filtriRicerca.valueSelected[4] = ''
          this.filtriRicerca.valueSelected[5] = ''
          this.filtriRicerca.valueSelected[6] = ''
          this.filtriRicerca.valueSelected[7] = []
          this.filtriRicerca.valueSelected[8] = []

          this.filtriRicerca.dati[1] = []
          this.filtriRicerca.dati[2] = []
          this.filtriRicerca.dati[3] = []
          this.filtriRicerca.dati[4] = []

          let form = {
            country: this.filtriRicerca.valueSelected[0],
            fornitore: {},
            statoAvanz: '',
            stabDest: {},
            locProv: '',
            subFornitore: '',
            numTrattativa: '',
            dataTrattativa: '',
            periodoVal: [],
            periodoConsSped: []
          }
          this.$set(this, 'form', form)
          this.$emit('resetPaginator')
          if (this.codForn !== '') {
            this.getStabilimenti()
            this.getStatiAvanzamento()
            this.getLocProv()
            this.getSubForn()
            this.cerca()
          }
        }
      })
      bus.$on('TRAACQ_ChangeCountryFromDsh', () => {
        this.filtriRicerca.valueSelected[0] = localStorage.getItem('TRAACQ_country')
      })
    },
    methods: {
       init: function () {
        this.setTraduzioniLabel()
        let ifRicerca = false
        let trattativaForm = this.$store.state.trattativaForm
        if (trattativaForm === undefined || (Object.keys(trattativaForm).length === 0 && trattativaForm.constructor === Object)) {
          ifRicerca = true
        } else {
          this.$set(this, 'form', trattativaForm)
          this.$set(this, 'codForn', trattativaForm.fornitore.tipForn + trattativaForm.fornitore.codForn)
          this.filtriRicerca.valueSelected[0] = trattativaForm.country
          this.filtriRicerca.valueSelected[1] = trattativaForm.statoAvanz
          this.filtriRicerca.valueSelected[2] = trattativaForm.stabDest
          this.filtriRicerca.valueSelected[3] = trattativaForm.locProv
          this.filtriRicerca.valueSelected[4] = trattativaForm.subFornitore
          this.filtriRicerca.valueSelected[5] = trattativaForm.numTrattativa
          this.filtriRicerca.valueSelected[6] = trattativaForm.dataTrattativa
          this.filtriRicerca.valueSelected[7] = trattativaForm.periodoVal
          this.filtriRicerca.valueSelected[8] = trattativaForm.periodoConsSped
        }
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codFornAdmin', JSON.parse(localStorage.getItem('amministrazione')))
        }
  
        this.getCountries(ifRicerca)
      },
      setTraduzioniLabel: function () {
        this.$set(this.filtriRicerca, 'titolo', this.$t('ricerca.filtri'))
        this.$set(this.filtriRicerca.filtri[0], 'myLabel', this.$t('ricerca.stato'))
        // this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.fornitore'))
        this.$set(this.filtriRicerca.filtri[1], 'myLabel', this.$t('ricerca.statoAvanz'))
        this.$set(this.filtriRicerca.filtri[2], 'myLabel', this.$t('ricerca.stabDestinazione'))
        this.$set(this.filtriRicerca.filtri[3], 'myLabel', this.$t('ricerca.locProvenienza'))
        this.$set(this.filtriRicerca.filtri[4], 'myLabel', this.$t('ricerca.subFornitore'))
        this.$set(this.filtriRicerca.filtri[5], 'myLabel', this.$t('ricerca.numTrattativa'))
        this.$set(this.filtriRicerca.filtri[6], 'myLabel', this.$t('ricerca.dataTrattativa'))
        this.$set(this.filtriRicerca.filtri[7], 'myLabel', this.$t('ricerca.periodoVal'))
        this.$set(this.filtriRicerca.filtri[8], 'myLabel', this.$t('ricerca.periodoConsSped'))
      },
      closeRicerca: function () {
        this.$emit('closeRicerca')
      },
      changeValueOrClick: function (index, value) {
        if (this.filtriRicerca.filtri[index].hasOwnProperty('onChangeOrClick')) {
          this[this.filtriRicerca.filtri[index].onChangeOrClick](value)
        }
      },
      cerca: function () {
        let fornitore = {
          codForn: this.codForn.substring(1),
          tipForn: this.codForn.substring(0, 1)
        }
        this.$set(this.form, 'fornitore', fornitore)
        this.$store.commit('setTrattativaForm', this.form)
        this.$emit('ricerca')
      },
      getCountries: function (ifRicerca) {
        this.$http.get('portale/countries', {
          params: {
            codLang: this.codLang,
            codiApp: 'WebTrattativaRottame'
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[0] = response.body.data
              if (this.filtriRicerca.valueSelected[0] === '') {
                let flag = false
                response.body.data.forEach((obj) => {
                  if (obj.country === localStorage.getItem('TRAACQ_country')) {
                    flag = true
                  }
                })
                if (flag === true) {
                  this.filtriRicerca.valueSelected[0] = localStorage.getItem('TRAACQ_country')
                  this.$set(this.form, 'country', localStorage.getItem('TRAACQ_country'))
                } else {
                  this.filtriRicerca.valueSelected[0] = response.body.data[0].country
                  this.$set(this.form, 'country', response.body.data[0].country)
                }
              }
              if (localStorage.hasOwnProperty('amministrazione') && this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]] !== '') {
                this.$set(this, 'codForn', this.codFornAdmin.TRAACQ[this.filtriRicerca.valueSelected[0]])
              }
              this.getFornitoreInfo(ifRicerca)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeCountry: function () {
        this.filtriRicerca.valueSelected[1] = ''
        this.filtriRicerca.valueSelected[2] = {}
        this.filtriRicerca.valueSelected[3] = ''
        this.filtriRicerca.valueSelected[4] = ''
        this.filtriRicerca.valueSelected[5] = ''
        this.filtriRicerca.valueSelected[6] = ''
        this.filtriRicerca.valueSelected[7] = []
        this.filtriRicerca.valueSelected[8] = []

        this.filtriRicerca.dati[1] = []
        this.filtriRicerca.dati[2] = []
        this.filtriRicerca.dati[3] = []
        this.filtriRicerca.dati[4] = []

        let form = {
          country: this.filtriRicerca.valueSelected[0],
          fornitore: {},
          statoAvanz: '',
          stabDest: {},
          locProv: '',
          subFornitore: '',
          numTrattativa: '',
          dataTrattativa: '',
          periodoVal: [],
          periodoConsSped: []
        }
        this.$set(this, 'form', form)
        this.$emit('resetPaginator')
        this.getFornitoreInfo()
      },
      getFornitoreInfo: function (ifRicerca) {
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + this.form.country + '/fornitore/info')
          .then(response => {
            if (response.body.rc === 0) {
              if (response.body.attrib.typeOfUser === 'fornitore') {
                // this.filtriRicerca.filtri[1].typeOfUser = 'fornitore'
                this.getStabilimenti()
                this.getStatiAvanzamento()
                this.getLocProv()
                this.getSubForn()
                if (ifRicerca === true) {
                  this.cerca()
                }
              } else if (response.body.attrib.typeOfUser === 'admin') {
                // this.filtriRicerca.filtri[1].typeOfUser = 'admin'
                if (this.codForn !== '') {
                  // this.getListFornAdm(this.form.fornitore.codForn)
                  this.getStabilimenti()
                  this.getStatiAvanzamento()
                  this.getLocProv()
                  this.getSubForn()
                  if (ifRicerca === true) {
                    this.cerca()
                  }
                } else {
                  this.$emit('stopLoading')
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getStabilimenti: function () {
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + this.form.country + '/stabilimenti', {
          params: {
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              data.forEach(obj => {
                obj.key = obj.codSoc + '-' + obj.codStab
              })
              this.filtriRicerca.dati[2] = data
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeStab: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'stabDest', this.filtriRicerca.valueSelected[2])
      },
      getStatiAvanzamento: function () {
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + this.form.country + '/statiavanzamento', {
          params: {
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[1] = response.body.data
            } else {
              /*
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              */
            }
          })
      },
      changeStatoAvanz: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'statoAvanz', this.filtriRicerca.valueSelected[1])
      },
      getLocProv: function () {
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + this.form.country + '/locprov', {
          params: {
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1),
            seFiltro: 'F',
            eleSubforn: []
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[3] = response.body.data
            } else {
              /*
               this.$message({
               showClose: true,
               message: response.body.msg[0].msgTxt,
               type: 'error',
               duration: process.env.duration
               })
               */
            }
          })
      },
      changeLocProv: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'locProv', this.filtriRicerca.valueSelected[3])
      },
      getSubForn: function () {
        this.$http.get(process.env.jaxrsFornRottame + this.codLang + '/spedizioni/trattativa/' + this.form.country + '/subforn', {
          params: {
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.filtriRicerca.dati[4] = response.body.data
            } else {
              /*
               this.$message({
               showClose: true,
               message: response.body.msg[0].msgTxt,
               type: 'error',
               duration: process.env.duration
               })
               */
            }
          })
      },
      changeSubForn: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'subFornitore', this.filtriRicerca.valueSelected[4])
      },
      changeNumTrattativa: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'numTrattativa', this.filtriRicerca.valueSelected[5])
      },
      changeDataTrattativa: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'dataTrattativa', (this.filtriRicerca.valueSelected[6] !== null) ? this.filtriRicerca.valueSelected[6] : '')
      },
      changePeriodoVal: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'periodoVal', (this.filtriRicerca.valueSelected[7] !== null) ? this.filtriRicerca.valueSelected[7] : [])
      },
      changePeriodoConsSped: function () {
        this.$emit('resetPaginator')
        this.$set(this.form, 'periodoConsSped', (this.filtriRicerca.valueSelected[8] !== null) ? this.filtriRicerca.valueSelected[8] : [])
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .ricerca {
    height: 100%;
    position: absolute;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneTrattativa/Ricerca.vue